import PropTypes from "../_util/vue-types";
import BaseMixin from "../_util/BaseMixin";
import LocaleReceiver from '../locale-provider/LocaleReceiver';
import { RecycleScroller } from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';

var SelectList = {
  mixins: [BaseMixin],
  props: {
    title: PropTypes.string,
    columnNames: PropTypes.array,
    popupColumnNames: PropTypes.array,
    fieldNames: PropTypes.object,
    prefixCls: PropTypes.string.def('rc-select-list'),
    selectorValueList: PropTypes.array
  },

  methods: {
    removeSelected: function removeSelected(event, item) {
      this.__emit('remove', event, item);
    },
    renderList: function renderList(locale) {
      var _this = this;

      var h = this.$createElement;
      var _$props = this.$props,
          title = _$props.title,
          prefixCls = _$props.prefixCls,
          columnNames = _$props.columnNames,
          fieldNames = _$props.fieldNames,
          popupColumnNames = _$props.popupColumnNames,
          _$props$selectorValue = _$props.selectorValueList,
          selectorValueList = _$props$selectorValue === undefined ? [] : _$props$selectorValue;

      var listPrefixCls = prefixCls + "-virtual-list";

      var label = columnNames && columnNames.length > 0 ? columnNames[columnNames.length - 1] : title;
      var columns = [{ value: 'label', label: label, width: '100%' }];
      var o = [{ value: 'o', label: locale.operate }];

      if (popupColumnNames && popupColumnNames.length > 0) {
        columns = popupColumnNames.map(function (_ref) {
          var field = _ref.field,
              name = _ref.name,
              render = _ref.render;

          return {
            value: Object.keys(fieldNames).find(function (k) {
              return fieldNames[k] === field;
            }) || field,
            label: name,
            width: parseInt(100 / popupColumnNames.length) + "%",
            render: render
          };
        });
      }
      columns = columns.concat(o);

      return h(
        "div",
        { "class": listPrefixCls },
        [h(
          "div",
          { "class": listPrefixCls + "-title" },
          [columns.map(function (_ref2) {
            var label = _ref2.label,
                width = _ref2.width;

            return h(
              "div",
              { style: { width: isNaN(width) ? width : width + "px" } },
              [label]
            );
          })]
        ), h(RecycleScroller, {
          attrs: {
            items: selectorValueList,
            "item-size": 30,
            "key-field": "key"
          },
          style: "height: calc(100% - 30px);",
          "class": listPrefixCls + "-body",
          scopedSlots: {
            "default": function _default(_ref3) {
              var item = _ref3.item;

              return h(
                "div",
                { "class": listPrefixCls + "-item" },
                [columns.map(function (_ref4) {
                  var value = _ref4.value,
                      width = _ref4.width,
                      render = _ref4.render;

                  if (value !== 'o') {
                    return h(
                      "div",
                      { style: { width: isNaN(width) ? width : width + "px" } },
                      [render ? render(item[value], item) : item[value]]
                    );
                  } else {
                    return h(
                      "div",
                      {
                        style: { width: isNaN(width) ? width : width + "px" },
                        "class": listPrefixCls + "-item-remove",
                        on: {
                          "click": function click(event) {
                            _this.removeSelected(event, item);
                          }
                        }
                      },
                      [locale["delete"]]
                    );
                  }
                })]
              );
            },
            before: function before() {
              return 'Header';
            }
          }
        })]
      );
    }
  },

  render: function render() {
    var h = arguments[0];

    return h(LocaleReceiver, {
      attrs: { componentName: "Cascader" },
      scopedSlots: { "default": this.renderList } });
  }
};

export default SelectList;